import LazyLoad from "vanilla-lazyload";

export const _lazyLoad = () => {
    const _instance = (window as any).lazyLoadInstance;

    if (!_instance) {
        (window as any).lazyLoadInstance = new LazyLoad({
            elements_selector: ".js-lazy, .js-lazy-bg",
            callback_enter: function (element: HTMLImageElement | HTMLElement) {
                if (element.dataset.src) {
                    element.src = element.dataset.src;
                    element.removeAttribute("data-src");
                }
                if (element.dataset.bg) {
                    element.style.backgroundImage = `url(${element.dataset.bg})`;
                    element.removeAttribute("data-bg");
                }
            },
        });
    } else {
        _instance.update();
    }
};
